<template>
	<div
		ref="singlesel"
		class="position-relative single-select ml-3"
		:class="{ 'not-selected': !selectedOption.value }"
	>
		<label class="d-flex"
			>{{ text }}<span v-show="isMandatory" class="asterik">*</span></label
		>
		<b-skeleton v-if="showLoader" height="38px"></b-skeleton>
		<template v-else>
			<b-dropdown
				:id="id"
				:boundary="'scroll-issue'"
				no-caret
				@shown="isDropdownOpen = true"
				@hidden="isDropdownOpen = false"
				:class="{
					'error-border': error,
					'grey-border': !error,
				}"
				:disabled="disabled"
			>
				<template #button-content>
					{{ selectedOption.text }}
					<img
						class=""
						:class="!isDropdownOpen ? 'pl-3' : 'up-arrow-rotate'"
						src="../assets/images/common/down-arrow-sm.svg"
					/>
				</template>

				<b-dropdown-item
					@click="selectOption(index)"
					:class="selectedOption.value == item.value ? 'selected-bg' : ''"
					v-for="(item, index) in optionsArray"
					:key="index"
				>
					<div class="d-flex justify-content-between">
						<div>
							{{ item.text }}
						</div>
						<img
							src="../assets/images/common/right-blue-arrow.svg"
							alt=""
							v-if="item.value == 'custom'"
						/>
					</div>
				</b-dropdown-item>
			</b-dropdown>
			<span v-show="error" class="required-font">Required</span>
		</template>
	</div>
</template>
	<script>
export default {
	name: "SingleSelect",
	props: {
		showLoader: {
			type: Boolean,
			default: false,
		},
		optionsArray: {
			type: Array,
			required: true,
		},
		text: {
			type: String,
			default: "Label",
		},
		isMandatory: {
			type: Boolean,
			default: true,
		},
		error: {
			type: Boolean,
			default: false,
		},
		selectedOptionProp: {
			type: Object,
			default: () => ({
				text: "Select",
				value: null,
			}),
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		noHide: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			selectedOption: {
				text: "Select",
				value: null,
			},
			isDropdownOpen: false,
		};
	},
	created() {
		this.selectedOption = this.selectedOptionProp;
	},
	watch: {
		selectedOptionProp: {
			handler(newValue) {
				this.selectedOption = newValue;
			},
		},
	},
	methods: {
		test() {
			if (this.noHide) {
				const div = document.getElementById(this.id);
				const ul = div.querySelector("ul");
				ul.style.setProperty("display", "block", "important");
			}
		},
		selectOption(index) {
			this.selectedOption = this.optionsArray[index];
			if (this.noHide) {
				const div = document.getElementById(this.id);
				const ul = div.querySelector("ul");
				ul.style.setProperty("display", "block", "important");
			}
			this.$emit("selectedOption", this.selectedOption);
		},
	},
};
</script>
	<style>
.single-select .dropdown .btn-secondary {
	background: var(--color-white);
	height: calc(1.5em + 0.75rem + 3px);
	width: 100%;
	font-size: var(--size-16);
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-400);
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	color: var(--input-text);
	padding: 10px 14px;
}

.not-selected .dropdown .btn-secondary {
	color: var(--input-placeholder) !important;
	height: calc(1.5em + 0.75rem + 3px);
	width: 100%;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	font-size: var(--size-16);
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-400);
	display: flex;
	align-items: center;
}
.not-selected .btn-secondary.disabled,
.btn-secondary:disabled {
	color: var(--input-text);
	background-color: #eeeeee;
	border-color: #6c757d;
	opacity: unset;
}
.single-select .btn-secondary:not(:disabled):not(.disabled):active,
.single-select .btn-secondary:not(:disabled):not(.disabled).active,
.single-select .show > .btn-secondary.dropdown-toggle,
.single-select .btn-secondary:not(:disabled):not(.disabled):active:focus,
.single-select .btn-secondary:not(:disabled):not(.disabled).active:focus,
.single-select .show > .btn-secondary.dropdown-toggle:focus {
	color: var(--input-text);
	border: 1px solid #d0d5dd;
	background-color: var(--color-white);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.single-select .btn-secondary:focus,
.btn-secondary.focus {
	color: var(--input-text);
	background-color: var(--color-white);
	border-color: #d0d5dd;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.single-select .grey-border .btn-secondary {
	border: 1px solid #d0d5dd !important;
}
.single-select .error-border .btn-secondary {
	border: 1px solid #eb0002 !important;
}
.single-select .dropdown-menu {
	position: absolute;
	top: 100%;
	left: 0;
	z-index: 6;
	display: none;
	float: left;
	width: 100%;
	min-width: 100%;
	padding: 0 0;
	margin: 0.2rem 0 0;
	font-size: var(--size-16);
	list-style: none;
	background-color: rgba(249, 249, 249, 1);
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 0.25rem;
	/* filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.4)); */
	box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.4);
	min-height: auto;
	max-height: 222px;
	overflow-y: auto;
}
.single-select .dropdown-item {
	display: block;
	padding: 0.5rem 0.5rem;
	font-weight: var(--weight-R);
	color: #3a3c40;
	border: none;
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-500);
}

.single-select .btn-group {
	width: 100%;
}

.up-arrow-rotate {
	transform: rotate(179deg);
}
.single-select .dropdown-menu.show {
	display: block !important;
}
.single-select .dropdown-item:hover,
.single-select .dropdown-item:focus {
	color: #3a3c40;
	text-decoration: none;
	background-color: #f9f9f9;
}

.single-select .dropdown-item:active {
	color: #3a3c40;
	text-decoration: none;
	background-color: #c8d9e5;
}
.selected-bg {
	background-color: #c8d9e5;
}
.title-sidebar {
	position: absolute;
	top: 18px;
	left: 34px;
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-600);
	font-size: 16px;
	color: #000000;
}
.single-select .dropdown-item:hover {
	background: #e8eff4;
}

.single-select .dropdown-menu::-webkit-scrollbar-thumb {
	background: #a9a9a9; /* Medium grey color */
	border-radius: 4px; /* Optional: Rounded corners */
}
</style>
